import React, { useContext, useEffect, useState } from 'react';
import { Box, Grid, Card, Stack, Typography } from '@mui/material';
import { genericGet } from '../../services/apiServices';
import {
    TOTAL_SUBSCRIPTION_LIST,
    TOTAL_PARTNER_SUBSCRIPTION_LIST,
} from '../../services/apiRoutes';
import { AuthContext } from '../../context/AuthContext';
import { t } from '../../constants/translationHelper';
import DirectionsBoatOutlinedIcon from '@mui/icons-material/DirectionsBoatOutlined';
import SailingOutlinedIcon from '@mui/icons-material/SailingOutlined';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import CheckCircleOutlinedIcon from '@mui/icons-material/CheckCircleOutlined';
import PendingActionsOutlinedIcon from '@mui/icons-material/PendingActionsOutlined';
import TransitEnterexitOutlinedIcon from '@mui/icons-material/TransitEnterexitOutlined';
import GroupAddOutlinedIcon from '@mui/icons-material/GroupAddOutlined';
import BusinessOutlinedIcon from '@mui/icons-material/BusinessOutlined';
import FormatListBulletedOutlinedIcon from '@mui/icons-material/FormatListBulletedOutlined';
/* ===================== STYLES & ICON MAP ===================== */

const colorMap = {
    1: { backgroundColor: '#FFD7E9', color: '#41001d' },
    2: { backgroundColor: '#f0ecff', color: '#0e0047' },
    3: { backgroundColor: '#d4d0c4', color: '#464133' },
    4: { backgroundColor: '#ffacb7', color: '#703d4f' },
    5: { backgroundColor: '#D9DFC6', color: '#576237' },
    6: { backgroundColor: '#dce5e8', color: '#253439' },
    7: { backgroundColor: '#C4D7FF', color: '#00143d' },
    8: { backgroundColor: '#e9ffe3', color: '#0a2d00' },
    9: { backgroundColor: '#e9ffe3', color: '#0a2d00' },
    10: { backgroundColor: '#ffacb7', color: '#703d4f' },
    11: { backgroundColor: '#dce5e8', color: '#253439' },
    12: { backgroundColor: '#C4D7FF', color: '#00143d' },
};

const iconMap = {
    1: <FormatListBulletedOutlinedIcon />,
    2: <BusinessOutlinedIcon />,
    3: <GroupAddOutlinedIcon />,
    4: <FormatListBulletedOutlinedIcon />,
    5: <BusinessOutlinedIcon />,
    6: <GroupAddOutlinedIcon />,
    7: <PendingActionsOutlinedIcon />,
    8: <TransitEnterexitOutlinedIcon />,
    9: <LocationOnOutlinedIcon />,
    10: <CheckCircleOutlinedIcon />,
    11: <PendingActionsOutlinedIcon />,
    12: <TransitEnterexitOutlinedIcon />,
};

/* ===================== REUSABLE CARD ===================== */

const CustomCard = ({ title, value, icon, style }) => (
    <Card
        variant="outlined"
        sx={{
            ...style,
            boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.2)',
            borderRadius: '10px',
        }}
    >
        <Box
            sx={{
                p: 2,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                position: 'relative',
            }}
        >
            <Box
                sx={{
                    position: 'absolute',
                    left: 16,
                    fontSize: { xs: 24, md: 40 },
                    color: style?.color,
                }}
            >
                {icon}
            </Box>

            <Stack alignItems="center">
                <Typography variant="h5" fontWeight="bold" sx={{ fontSize: '30px' }} >
                    {value}
                </Typography>
                <Typography variant="body2" fontWeight={500} textAlign="center">
                    {t(title)}
                </Typography>
            </Stack>
        </Box>
    </Card>
);

/* ===================== REUSABLE CARD GRID ===================== */

const CardGrid = ({ apiUrl, title }) => {
    const [cardData, setCardData] = useState([]);
    const { token } = useContext(AuthContext);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await genericGet({ url: apiUrl });
                if (response?.data?.success) {
                    setCardData(response.data.cardData || []);
                }
            } catch (error) {
                console.error('API Error:', error);
            }
        };

        fetchData();
    }, [apiUrl, token]);

    return (
        <Box>
            {/* GRID TITLE */}
            <Typography
                variant="h4"
                sx={{
                    mb: 2,
                    fontWeight: 600,
                    color: '#1a1a1a',
                }}
            >
                {t(title)}
            </Typography>

            <Grid container spacing={2}>
                {cardData.map((data) => (
                    <Grid item xs={12} sm={4} md={4} key={data.id}>
                        <CustomCard
                            title={data.title}
                            value={data.value}
                            icon={iconMap[data.id] || <DirectionsBoatOutlinedIcon />}
                            style={colorMap[data.id] || { backgroundColor: '#fff', color: '#000' }}
                        />
                    </Grid>
                ))}
            </Grid>
        </Box>

    );
};

/* ===================== MAIN DASHBOARD ===================== */

const DashboardPartner = () => {
    return (
        <Box sx={{ p: 2 }}>
            <Box sx={{ my: 3 }} />
            <CardGrid
                apiUrl={TOTAL_SUBSCRIPTION_LIST}
                title="Total Paid Subscription Summary"

            />
        </Box>
    );
};

export default DashboardPartner;
